import script from "./AssessmentBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentBuilder.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentBuilder.vue?vue&type=style&index=0&id=57f32f7a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f32f7a"]])

export default __exports__